import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

export default function DateRange(props) {
  const { userParams, setUserParams } = props;
  var justym = userParams.datePickerViews && userParams.datePickerViews.toString() === 'year,month';

  const handleDateChange = (name) => event => {
    const dt = event;
    setUserParams({ ...userParams, [name]: dt})
  }

  const handlePorClick = (event) => {
    var newToDate;
    const syear = userParams.stnName.slice(-12,-8)
    const eyear = userParams.stnName.slice(-5,-1)
    const today = dayjs();
    if (justym) {
      newToDate = eyear === today.year().toString() ? dayjs().endOf('month') : dayjs(eyear+"-12-31") 
    } else {
      newToDate = eyear === today.year().toString() ? dayjs() : dayjs(eyear+"-12-31") 
    }
    setUserParams({ 
      ...userParams, 
      //these could be refined to actual end mm-dd with call to StnMeta
      fromDate: dayjs(syear+'-01-01'), 
      toDate: newToDate
    })
  }

/*   useEffect(() => {
    // when changing station, period of record may change, so adjust range to fall within por bounds
    const sPorYear = parseInt(userParams.stnName.slice(-12,-8))
    const ePorYear = parseInt(userParams.stnName.slice(-5,-1))
    const fromyear = userParams.fromDate.year()
    const toyear = userParams.toDate.year()
    if (fromyear < sPorYear) {
      setUserParams({ ...userParams, fromDate: userParams.fromDate.year(sPorYear)})
    }
    if (toyear > ePorYear) {
      setUserParams({ ...userParams, toDate: userParams.toDate.year(ePorYear)})
    }
  }, [userParams.stnName]) */

  return (
    <>
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <DatePicker 
          label="Start date"
          value={userParams.fromDate}
          views={userParams.datePickerViews || ['year','month','day']}
          onChange={handleDateChange("fromDate")}
          format={justym ? "YYYY-MM" : "YYYY-MM-DD"}
          minDate={dayjs('1895-1-1')}
          maxDate={userParams.toDate}
          slotProps={{ textField: { sx: { width: "10rem" } } }}
        />
        <DatePicker 
          label="End date"
          value={userParams.toDate}
          views={userParams.datePickerViews || ['year','month','day']}
          onChange={handleDateChange("toDate")}
          format={justym ? "YYYY-MM" : "YYYY-MM-DD"}
          minDate={userParams.fromDate}
          maxDate={justym ? dayjs().endOf('month') : dayjs()}
          slotProps={{ textField: { sx: { width: "10rem" } } }}
        />
        {(userParams.hasOwnProperty('stnName') && userParams.stnName.length > 0 && userParams.stnName !== "Unknown id") &&
          <Button 
            variant="light"
            onClick={handlePorClick}
          >
            Set to period of record
          </Button>
        }
      </Stack>
    </>
  )
}